module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_4-78328a16da58181ee722eff5d724b26a.jpg";